import Component from '@glimmer/component';

import type { Recipient } from 'webapp-types';

import highlightResult from 'webapp/helpers/highlight-result';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	recipients: Recipient[];
	activeFilter?: string[];
}

export default class CommonRecipientsListComponent extends Component<Args> {
	get hasMoreRecipients() {
		return this.args.recipients.length > 3;
	}

	get shownRecipients() {
		const shownRecipients = (this.args.recipients || []).slice(0, 3).map((recipient) => {
			let icon: IconName = 'UserProfile';
			let isStrokeIcon = false;

			if (recipient.isSlack) {
				icon = 'BrandSlack';
				isStrokeIcon = true;
			} else if (!recipient.isDatabox) {
				icon = 'Globe';
			}

			return { ...recipient, icon, isStrokeIcon };
		});

		return shownRecipients;
	}

	get hiddenRecipientsText() {
		let text = '',
			hiddenCount;
		if (this.hasMoreRecipients) {
			hiddenCount = this.args.recipients.length - 3;
			text += ' & ' + hiddenCount + ' other' + (hiddenCount !== 1 ? 's' : '');
		}
		return text;
	}
	<template>
		<div class="recipients-list">
			<ul class="list">
				{{#each this.shownRecipients as |recipient|}}
					<li>
						{{#if recipient.isStrokeIcon}}
							<CommonUiIconComponent
								@name={{recipient.icon}}
								@size="sm"
								@stroke="currentColor"
								@fill="none"
							/>
						{{else}}
							<CommonUiIconComponent @name={{recipient.icon}} @size="sm" />
						{{/if}}
						<span>
							{{highlightResult text=recipient.name match=@activeFilter}}
						</span>
					</li>
				{{/each}}
			</ul>
			{{#if this.hasMoreRecipients}}
				<div>{{this.hiddenRecipientsText}}</div>
			{{/if}}
		</div>
	</template>
}
